import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
// import CustomDatePicker from "./CustomDatePicker"; // Not used in current Header structure
import Popover from "@mui/material/Popover";
import { useState } from "react";
import NotificationPanel from "../../NotificationPanel";
import ColorModeIconDropdown from "../../shared-theme/ColorModeIconDropdown";
import NavbarBreadcrumbs from "./NavbarBreadcrumbs";
import Search from "./Search";

export default function Header({ isSidebarCollapsed }) {
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
    setNotificationOpen(true);
  };
  const handleNotificationClose = () => {
    setNotificationOpen(false);
    setAnchorEl(null);
  };
  return (
    <Stack
      direction="row"
      sx={{
        display: { md: "flex" },
        width: "100%",
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        maxWidth: { sm: "100%", md: "1700px" },
        pt: 1.5,
      }}
      spacing={2}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {" "}
        {/* Group breadcrumbs only */}
        <NavbarBreadcrumbs />
      </Stack>

      <Stack direction="row" spacing={1}>
        <Search />
        <IconButton
          color="inherit"
          aria-label="Open notifications"
          onClick={handleNotificationClick}
          sx={{ height: 36, width: 36 }}
        >
          <NotificationsRoundedIcon sx={{ height: 18, width: 18 }} />
        </IconButton>
        <ColorModeIconDropdown />
      </Stack>
      {notificationOpen && (
        <Popover
          open={notificationOpen}
          anchorEl={anchorEl}
          onClose={handleNotificationClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              mt: 1.5,
              boxShadow: 3,
              borderRadius: 2,
              width: 420,
              overflow: "visible", // ⚠️ ensure this is not 'auto'
              maxHeight: "none", // 🛑 override default scroll limit
              backgroundColor: "white",
            },
          }}
        >
          <NotificationPanel />
        </Popover>
      )}
    </Stack>
  );
}
